import React, {useEffect, useState} from 'react';
import {Box, Button, Checkbox, Tabs, Tooltip} from "@mui/material";
import RequestsCuttingTable from "../../../components/UI/table/optimization/requestscutting/RequestsCuttingTable";
import UploadFilesRequestsForm from "../../organization/orders/estimate/UploadFilesRequestsForm";
import CheckIcon from "@mui/icons-material/Check";
import {ButtonGroupTabBar} from "../../../components/UI/button/ButtonGroupTabBar";
import FileService from "../../../API/orders/orders/customer/FileService";
import Typography from "@mui/material/Typography";
import CustomerUpload3DModelTable from "../../../components/UI/table/orders/customer/order/CustomerUpload3DModelTable";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import ThreeDConverterService from "../../../API/threedconverter/ThreeDConverterService";

const CustomerRequestsCuttingEstimateItem = ({
                                                 getAll,
                                                 isOptimization,
                                                 isRedirectRequestsCutting,
                                                 orderId,
                                                 nameOrder,
                                                 idHeader,
                                                 year,
                                                 isOrder,
                                                 isCloud,
                                                 isButtonAddRequestsCutting,
                                                 isEstimate,
                                                 isCreateOptimizationCalculation,
                                                 isSetForOptimization,
                                                 customerOrderNumber,
                                                 isOrgOne,
                                                 offersData,
                                                 handleModalAlert
                                             }) => {

    const [tab, setTab] = useState(1);
    const [checkModel, setCheckModel] = useState(false)

    const [rowSelection, setRowSelection] = useState([]);
    const [data, setData] = useState([]);

    const [disableImport, setDisableImport] = useState(false)
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`customer/orders`, "pageSize", nextState.pageSize)
        }
    }

    useEffect(() => {
        // На cloud-странице вкладка «Импорт» скрыта — 3D-список не нужен.
        if (isCloud) {
            return;
        }
        ThreeDConverterService.getAllByOrderId(orderId).then(function (response) {
            let data = response.data;
            setData(data);
            setTableOptions((prev) => ({...prev, totalElements: data.length}))
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, [isCloud, orderId]);

    const uploadData = (() => {
        const data = [{
            id: 1,
            helpText: "Импорт заявок на раскрой из файлов раскроя базис-мебельщика, с добовлением материала в смету",
            upload: FileService.uploadRequestsCuttingFiles,
            multiple: true,
            calculationRequestsCutting: false
        },
            {
                id: 2,
                helpText: "Импорт заявок на раскрой из файлов раскроя базис-мебельщика, с добовлением материала в смету, с использованием шаблонов *.xls",
                upload: FileService.uploadRequestsCuttingFilesWithSample,
                multiple: true,
                calculationRequestsCutting: false
            },];

        if (isOrgOne) {
            data.push({
                id: 3,
                helpText: "Импортировать 3D модель",
                upload: ThreeDConverterService.uploadB3d,
                checkB3dExtension: true,
                multiple: false,
            });
        }

        return data;
    })();

    const handleChange = (event, newValue) => {
        setTab(newValue);
    };

    const [change, setChange] = useState(false);

    return (
        <Box sx={{display: "flex", flexDirection: "column", gap: "32px"}}>
            <ButtonGroupTabBar activeTab={tab}>
                <Button tabIndex={1} onClick={(e) => handleChange(e, 1)}>
                    <CheckIcon/>
                    Заявки на раскрой
                </Button>
                {!isCloud && <Button tabIndex={2} onClick={(e) => handleChange(e, 2)}>
                    <CheckIcon/>
                    Импорт
                </Button>}
            </ButtonGroupTabBar>
            {tab === 1 ? <RequestsCuttingTable
                getAll={getAll}
                isOptimization={isOptimization}
                isRedirectRequestsCutting={isRedirectRequestsCutting}
                orderId={orderId}
                nameOrder={nameOrder}
                idHeader={idHeader}
                year={year}
                isOrder={isOrder}
                isButtonAddRequestsCutting={isButtonAddRequestsCutting}
                isEstimate={isEstimate}
                isCreateOptimizationCalculation={isCreateOptimizationCalculation}
                isSetForOptimization={isSetForOptimization}
                hideOrder={true}
                hideWorkingCuttingMap={true}
                customer={!isCloud}
                customerOrderNumber={customerOrderNumber}
                isButtonCreate={true}
                isCloud={isCloud}
                isOrgOne={isOrgOne}
                offersData={offersData}
            /> : <Box>
                {uploadData.map(el => <Box sx={{display: "flex", gap: "24px"}}>
                    <UploadFilesRequestsForm
                        orderId={orderId}
                        change={change}
                        setChange={setChange}
                        calculationRequestsCutting={el.calculationRequestsCutting}
                        uploadData={el}
                        handleModalAlert={handleModalAlert}
                        checkB3dExtension={el.checkB3dExtension}
                        multiple={el.multiple}
                        checkModel={checkModel}
                        disableImport={disableImport}
                        setDisableImport={setDisableImport}
                    />
                    {el.checkB3dExtension && <Box sx={{display: "flex", height: "35px", alignItems: "center"}}>
                        <Checkbox
                            onChange={(event) => setCheckModel(event.target.checked)}
                            checked={checkModel}
                        />
                        <Typography component="p" sx={{fontSize: "20px",}}>
                            Анализ ошибок модели
                        </Typography>
                    </Box>}
                </Box>)}
                <CustomerUpload3DModelTable
                    data={data}
                    setData={setData}
                    rowSelection={rowSelection}
                    setRowSelection={setRowSelection}
                    handleModalAlert={handleModalAlert}
                    tableOptions={tableOptions}
                    tableOptionsHandle={tableOptionsHandle}
                    orderId={orderId}
                    nameOrder={nameOrder}
                    year={year}
                >
                </CustomerUpload3DModelTable>
            </Box>}

        </Box>
    );
};

export default CustomerRequestsCuttingEstimateItem;